const WHATSAPP_SUPPORT_NUMBER = "37477988325";
export const getWhatsAppUrl = () => `https://wa.me/${WHATSAPP_SUPPORT_NUMBER}`;

const SUPPORT_PHONE_NUMBER = "+37477300325";
export const getTelUrl = () => `tel:${SUPPORT_PHONE_NUMBER}`;

// todo add second number latter with custom dropdown for user to choose
// const SUPPORT_PHONE_NUMBER_1 = "+37477300325";
// const SUPPORT_PHONE_NUMBER_2 = "+37411223344";  // your second number

// export const getTelUrl = (phoneNumber: string) => `tel:${phoneNumber}`;

// export const getWhatsAppUrl = () => `https://wa.me/${WHATSAPP_SUPPORT_NUMBER}`;
